export const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL!;
export const clerkPublishableKey =
  process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY!;
export const API_JWT_SECRET = process.env.API_JWT_SECRET;
export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL!;
export const WEBSITE_NAME = process.env.NEXT_PUBLIC_WEBSITE_NAME!;
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const APP_ENV = process.env.APP_ENV;
